import React from "react";

function Header() {
  return (
    <div>
      <h1 className="header">Battleships</h1>
    </div>
  );
}

export default Header;
